import { graphql } from '@/lib/query'
import LinkFragment from '../link'

const MenuItemFragment = graphql(
  /* GraphQL */ `
    fragment MenuItemFragment on MenuItemRecord @_unmask {
      _modelApiKey
      id
      firstLevel {
        ...LinkFragment
      }
      dropdownItems {
        ...LinkFragment
      }
    }
  `,
  [LinkFragment]
)

export default MenuItemFragment
